<template>
  <div v-if="visible" class="youth-banner">
    <div class="banner-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>
    </div>
    <div class="banner-body">
      <h4 class="banner-title">青少年保护模式已开启</h4>
      <p class="banner-desc">
        当前账号处于青少年保护模式下，<strong>{{ blockedText }}</strong>
        <template v-if="usageText"><br />{{ usageText }}</template>
      </p>
    </div>
    <router-link to="/youth-mode" class="banner-link">前往设置</router-link>
  </div>
</template>

<script>
import { getYouthConfig } from '@/api/index';

export default {
  name: 'YouthModeBanner',
  data() {
    return {
      visible: false,
      dailyTimeLimit: 0,
      usageMinutes: 0,
    };
  },
  computed: {
    blockedText() {
      const parts = [];
      if (this.blocksPurchase) parts.push('无法进行充值与购买');
      parts.push(`每日使用时长限制为 ${this.dailyTimeLimit} 分钟`);
      return parts.join('，');
    },
    usageText() {
      if (!this.dailyTimeLimit) return '';
      if (this.usageMinutes >= this.dailyTimeLimit) {
        return `今日已使用 ${this.usageMinutes} 分钟，已达到上限`;
      }
      return `今日已使用 ${this.usageMinutes} / ${this.dailyTimeLimit} 分钟`;
    },
  },
  props: {
    // 是否需要提示"无法购买"（支付页传 true）
    blocksPurchase: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.loadStatus();
  },
  methods: {
    async loadStatus() {
      const token = localStorage.getItem('userToken');
      if (!token) return;
      try {
        const res = await getYouthConfig();
        if (res.data && res.data.code === 1) {
          const data = res.data.data;
          this.visible = !!data.enabled;
          this.dailyTimeLimit = data.daily_time_limit || 0;
          this.usageMinutes = data.usage_minutes || 0;
          this.$emit('status', {
            enabled: !!data.enabled,
            dailyTimeLimit: this.dailyTimeLimit,
            usageMinutes: this.usageMinutes,
          });
        }
      } catch (e) {
        // 加载失败时不展示，不影响主流程
      }
    },
  },
};
</script>

<style scoped>
.youth-banner {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 20px;
  margin-bottom: 20px;
  background: rgba(96, 165, 250, 0.12);
  border: 1px solid rgba(96, 165, 250, 0.4);
  border-radius: 14px;
}

.banner-icon {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  color: var(--brand);
}

.banner-icon svg {
  width: 100%;
  height: 100%;
}

.banner-body {
  flex: 1;
  min-width: 0;
}

.banner-title {
  margin: 0 0 4px 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--text);
}

.banner-desc {
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
  color: var(--text-dim);
}

.banner-desc strong {
  color: var(--brand);
  font-weight: 600;
}

.banner-link {
  flex-shrink: 0;
  padding: 8px 16px;
  background: var(--brand);
  color: #fff;
  border-radius: 8px;
  font-size: 13px;
  text-decoration: none;
  transition: opacity 0.2s;
}

.banner-link:hover {
  opacity: 0.85;
}

@media (max-width: 768px) {
  .youth-banner {
    flex-wrap: wrap;
    padding: 14px 16px;
  }

  .banner-link {
    width: 100%;
    text-align: center;
  }
}
</style>
